// Imports
import { doesItemMatch } from './wpn2Model.js';

export function filterForMatchingItems(data, options = {}) {
    if (!Array.isArray(data) || data.length === 0) {
        return [];
    }
    // Define option keys in search order
    const { searchText, entity, infrastructure, systemType, docType, dateRange } = options;

    return data.filter(item => {
        if (searchText && searchText.length > 0 && !doesItemMatch(item, searchText)) {
            return false;
        }
        if (entity && entity !== "all" && item.entity !== entity) {
            return false;
        }
        if (infrastructure && infrastructure !== "all" && item.infrastructure !== infrastructure) {
            return false;
        }
        if (systemType && systemType !== "all") {
            const isService = systemType.toUpperCase() === "SERVICE";
            if ((isService && item.sub_type !== "Service") || (!isService && item.sub_type === "Service")) {
                return false;
            }
        }
        if (docType && docType !== "all" && item.wpn2_type !== docType) {
            return false;
        }
        if (dateRange && dateRange !== "all") {
            const [start, end] = dateRangeForOption(dateRange);
            if (!(item.last_updated >= start && item.last_updated <= end)) {
                return false;
            }
        }
        return true;
    });
}

export function sortByStatus(items, sortOrder) {
    if (!Array.isArray(items)) {
        return items;
    }
    const entity = items[0]?.entity || null;
    if (entity == 'Sensor') {
        return items.sort((a, b) => sortOrder * (parseFloat(a.alert_index ?? -1) - parseFloat(b.alert_index ?? -1)));
    }
    let colorOrder = {"Gray": 0, "Green": 1, "Yellow": 2, "Red": 3};
    return items.sort((a, b) => {
        // Use fallback values in case the status is undefined.
        const aStatus = colorOrder[a.status] ?? -1;
        const bStatus = colorOrder[b.status] ?? -1;
        return sortOrder * (bStatus - aStatus);
      });
}

function dateRangeForOption(dateRangeOption) {
    var currentTime = new Date().getTime();
    if (dateRangeOption == "lastDays7") {
        return [(currentTime - (86400 * 7 * 1000)), currentTime];
    } else if (dateRangeOption == "lastDays30") {
        return [(currentTime - (86400 * 30 * 1000)), currentTime];
    } else if (dateRangeOption == "lastDays90") {
        return [(currentTime - (86400 * 90 * 1000)), currentTime];
    } else if (dateRangeOption == "lastDays365") {
        return [(currentTime - (86400 * 365 * 1000)), currentTime];
    } else if (dateRangeOption == "thisYear") {
        var yearCount = new Date().getFullYear();
        var yearDay1Time = (yearCount - 1970) * 365 * 86400 *1000;
        return [yearDay1Time, currentTime];
    } else if (dateRangeOption == "lastYear") {
        var yearCount = new Date().getFullYear();
        var lastYearDay1Time = ((yearCount - 1) - 1970) * 365 * 86400 *1000;
        var lastYearDay365Time = (yearCount - 1970) * 365 * 86400 *1000 - 1;
        return [lastYearDay1Time, lastYearDay365Time]
    }
    return [0, currentTime];
}
